
import { motion } from 'framer-motion';

export const WelcomeHero = () => {
  return (
    <div className="text-center space-y-2 sm:space-y-6 max-w-3xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="space-y-2 sm:space-y-4"
      >
        <span className="inline-block bg-accent text-accent-foreground px-2 py-1 text-xs sm:text-sm font-medium rounded-full">
          🧪 Kitchen Science for Kids!
        </span>
        <h1 className="text-2xl sm:text-4xl md:text-6xl font-bold text-foreground leading-tight px-2">
          Mini Makes Magic
        </h1>
        <p className="text-sm sm:text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto px-3">
          Where tiny hands create big kitchen adventures!
        </p>
      </motion.div>
    </div>
  );
};
